<p>te-role-auth works!</p>
